import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ORANGE = "#f97316";
const GREEN  = "#16a34a";

function BrandText() {
  return (
    <span style={brandSpan}>
      <span style={{ color: ORANGE }}>Play Online </span>
      <span style={{ color: GREEN }}>Satta Matka</span>
    </span>
  );
}

export default function PublicNav() {
  const navigate  = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const links = [
    { label: "Home",     action: () => navigate("/")          },
    { label: "Charts",   action: () => navigate("/charts")    },
    { label: "Blog",     action: () => navigate("/blog")      },
    { label: "About Us", action: () => navigate("/about-us")  },
    { label: "FAQ",      action: () => navigate("/faq")       },
  ];

  const go = (fn) => { setMenuOpen(false); fn(); };

  return (
    <>
      {/* overlay */}
      {menuOpen && <div style={overlay} onClick={() => setMenuOpen(false)} />}

      {/* drawer */}
      <aside style={{ ...drawer, transform: menuOpen ? "translateX(0)" : "translateX(-100%)" }}>
        <div style={drwHead}>
          <BrandText />
          <button style={iconBtn} onClick={() => setMenuOpen(false)}><X size={20} /></button>
        </div>
        {links.map((n) => (
          <button key={n.label} style={drwItem} onClick={() => go(n.action)}>{n.label}</button>
        ))}
        <button style={{ ...drwItem, background: ORANGE, color: "#fff", borderColor: ORANGE }}
          onClick={() => go(() => navigate("/login"))}>
          Login / Play
        </button>
      </aside>

      {/* header */}
      <header style={hdr}>
        <button style={brandBtn} onClick={() => navigate("/")}><BrandText /></button>

        {!isMobile && (
          <nav style={topNav}>
            {links.map((n) => (
              <button key={n.label} style={navBtn} onClick={n.action}>{n.label}</button>
            ))}
            <button style={navBtnPrimary} onClick={() => navigate("/login")}>Login / Play</button>
          </nav>
        )}

        {isMobile && (
          <button style={iconBtn} onClick={() => setMenuOpen(true)}><Menu size={26} color="#111827" /></button>
        )}
      </header>
    </>
  );
}

const overlay    = { position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 90 };
const drawer     = { position: "fixed", top: 0, left: 0, bottom: 0, width: 270, background: "#fff", zIndex: 100, padding: "14px 14px 24px", display: "flex", flexDirection: "column", gap: 10, boxShadow: "4px 0 24px rgba(0,0,0,.14)", transition: "transform .28s ease", overflowY: "auto" };
const drwHead    = { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 };
const drwItem    = { padding: "13px 14px", border: "1.5px solid #e5e7eb", borderRadius: 10, background: "#fff", textAlign: "left", fontWeight: 700, fontSize: 15, cursor: "pointer", color: "#111827" };
const hdr        = { position: "sticky", top: 0, zIndex: 80, background: "#fff", borderBottom: "1px solid #e5e7eb", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 20px", height: 62, boxShadow: "0 2px 8px rgba(0,0,0,.06)" };
const brandBtn   = { border: 0, background: "transparent", padding: 0, cursor: "pointer", display: "inline-flex", alignItems: "center" };
const brandSpan  = { fontSize: 20, fontWeight: 900, letterSpacing: 0 };
const iconBtn    = { border: 0, background: "#f3f4f6", borderRadius: 9, padding: 8, cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center" };
const topNav     = { display: "flex", alignItems: "center", gap: 8 };
const navBtn     = { padding: "8px 16px", borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#fff", color: "#111827", fontWeight: 700, fontSize: 14, cursor: "pointer" };
const navBtnPrimary = { ...navBtn, background: ORANGE, borderColor: ORANGE, color: "#fff" };
